import { CSSProperties, FC, ReactNode } from 'react'

export const View: FC<{
  children?: ReactNode
  customStyle?: CSSProperties
}> = ({ children, customStyle }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'stretch',
        flexShrink: 0,
        border: '0 solid black',
        margin: 0,
        padding: 0,
        minWidth: 0,
        boxSizing: 'border-box',
        ...customStyle,
      }}
    >
      {children}
    </div>
  )
}
